<div class="row">
    <div class="col-12 mb-4">
        <div class="row g-2">
            <div class="col d-grid">
                <div class="card card-border-shadow-danger card-count">
                    <div class="card-body">
                        <div class="stat-card-content">
                            <h5 class="mb-0 kpi-number kpi-danger">{{unitStatistics.criticas}}</h5>
                            <div class="avatar kpi-icon">
                                <span class="avatar-initial rounded bg-label-danger">
                                    <img src="../../../../assets/img/icons/alert-02.svg" alt="" class="p-1">
                                </span>
                            </div>
                            <p class="mb-0 kpi-label">Críticas</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col d-grid">
                <div class="card card-border-shadow-warning card-count">
                    <div class="card-body">
                        <div class="stat-card-content">
                            <h5 class="mb-0 kpi-number kpi-warning">{{unitStatistics.en_reparacion}}</h5>
                            <div class="avatar kpi-icon">
                                <span class="avatar-initial rounded bg-label-warning">
                                    <img src="../../../../assets/img/icons/configuration-01.svg" alt="" class="p-1">
                                </span>
                            </div>
                            <p class="mb-0 kpi-label">En reparación</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col d-grid">
                <div class="card card-border-shadow-primary card-count">
                    <div class="card-body">
                        <div class="stat-card-content">
                            <h5 class="mb-0 kpi-number kpi-primary">{{unitStatistics.pendientes}}</h5>
                            <div class="avatar kpi-icon">
                                <span class="avatar-initial rounded bg-label-primary">
                                    <img src="../../../../assets/img/icons/clock.svg" alt="" class="p-1">
                                </span>
                            </div>
                            <p class="mb-0 kpi-label">Pendientes</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col d-grid">
                <div class="card card-border-shadow-info card-count">
                    <div class="card-body">
                        <div class="stat-card-content">
                            <h5 class="mb-0 kpi-number kpi-info">{{unitStatistics.programadas}}</h5>
                            <div class="avatar kpi-icon">
                                <span class="avatar-initial rounded bg-label-info">
                                    <img src="../../../../assets/img/icons/calendar.svg" alt="" class="p-1">
                                </span>
                            </div>
                            <p class="mb-0 kpi-label">Programadas</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col d-grid">
                <div class="card card-border-shadow-success card-count">
                    <div class="card-body">
                        <div class="stat-card-content">
                            <h5 class="mb-0 kpi-number kpi-success">{{unitStatistics.finalizadas}}</h5>
                            <div class="avatar kpi-icon">
                                <span class="avatar-initial rounded bg-label-success">
                                    <img src="../../../../assets/img/icons/checkmark-circle.svg" alt="" class="p-1">
                                </span>
                            </div>
                            <p class="mb-0 kpi-label">Finalizadas</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="col-xl">
    <div class="card">
        <div class="card-header">
            <div class="d-flex align-items-center filter-toolbar">
                <button class="btn btn-primary"
                    *ngIf="role?.name == 'Administrador' || role?.name == 'Supervisor de mantenimiento'"
                    [routerLink]="['/maintenance/add']">
                    <i class="ti ti-plus me-1"></i> Crear reporte de falla
                </button>
                <button class="btn btn-outline-primary ms-auto btn-filter-toggle" (click)="showFilters = true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M9.99988 20C9.9998 20.1858 10.0515 20.368 10.1492 20.5261C10.2469 20.6842 10.3867 20.8119 10.5529 20.895L12.5529 21.895C12.7054 21.9712 12.8748 22.0072 13.0451 21.9994C13.2154 21.9917 13.3809 21.9406 13.5259 21.8509C13.6709 21.7613 13.7905 21.636 13.8735 21.4871C13.9565 21.3381 14 21.1705 13.9999 21V14C14.0001 13.5044 14.1843 13.0265 14.5169 12.659L21.7399 4.67C21.8693 4.52656 21.9545 4.34868 21.985 4.15788C22.0155 3.96708 21.9901 3.77153 21.9118 3.59487C21.8335 3.41822 21.7057 3.26802 21.5439 3.16245C21.3821 3.05688 21.1931 3.00046 20.9999 3H2.99988C2.80649 3.00007 2.61727 3.05622 2.45513 3.16164C2.293 3.26706 2.16491 3.41723 2.08639 3.59396C2.00786 3.7707 1.98227 3.96641 2.01271 4.15739C2.04315 4.34837 2.12831 4.52643 2.25788 4.67L9.48288 12.659C9.81542 13.0265 9.99966 13.5044 9.99988 14V20Z" stroke="#019DDA" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>&nbsp; Filtrar productos
                </button>
            </div>

            <!-- Filter panel: inline en PC, action sheet en responsive -->
            <div class="filter-panel" [class.show]="showFilters">
                <div class="filter-panel-drag">
                    <span class="filter-panel-handle"></span>
                </div>
                <div class="filter-panel-header">
                    <h6 class="mb-0 fw-semibold">Filtrar órdenes</h6>
                    <button type="button" class="btn-close" (click)="showFilters = false"></button>
                </div>

                <form [formGroup]="filterForm">
                    <div class="row g-3" *ngIf="role?.name == 'Administrador' || role?.name == 'Supervisor de mantenimiento'">
                        <div class="col">
                            <label class="form-label text-base">Fecha de solicitud</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" placeholder="dd/mm/yyyy" id="request_date"
                                    #requestDate autocomplete="off" readonly formControlName="request_date">
                                <span class="input-group-text" (click)="filterForm.get('request_date')!.value ? removeDate('request_date') : $event.preventDefault(); requestDate.focus()">
                                    <i class="{{filterForm.get('request_date')!.value ? 'ti ti-x' : 'ti ti-calendar'}}"></i>
                                </span>
                            </div>
                        </div>
                        <div class="col">
                            <label class="form-label text-base">Fecha de reparación</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" placeholder="dd/mm/yyyy" id="date_repair"
                                    #dateRepair autocomplete="off" readonly formControlName="date_repair">
                                <span class="input-group-text" (click)="filterForm.get('date_repair')!.value ? removeDate('date_repair') : $event.preventDefault(); dateRepair.focus()">
                                    <i class="{{filterForm.get('date_repair')!.value ? 'ti ti-x' : 'ti ti-calendar'}}"></i>
                                </span>
                            </div>
                        </div>
                        <div class="col">
                            <label class="form-label text-base">Unidad</label>
                            <select class="form-select" formControlName="unit_id">
                                <option value="">Seleccionar</option>
                                <option *ngFor="let unit of units" [value]="unit.id">{{unit.unit}}</option>
                            </select>
                        </div>
                        <div class="col">
                            <label class="form-label text-base">Tipo de mantenimiento</label>
                            <select class="form-select" formControlName="maintenance_type_id">
                                <option value="">Seleccionar</option>
                                <option *ngFor="let type of maintenanceType" [value]="type.id">{{type.name}}</option>
                            </select>
                        </div>
                        <div class="col">
                            <label class="form-label text-base">Estado</label>
                            <select class="form-select" formControlName="maintenance_status_id">
                                <option value="">Seleccionar</option>
                                <option *ngFor="let status of statusMaintenance" [value]="status.id">{{status.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row g-3" *ngIf="role?.name == 'Administrativo'">
                        <div class="col">
                            <label class="form-label text-base">Folio</label>
                            <input type="text" class="form-control" placeholder="Ingresar" autocomplete="off"
                                formControlName="folio">
                        </div>
                        <div class="col">
                            <label class="form-label text-base">Fecha de solicitud</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" placeholder="dd/mm/yyyy" id="request_date"
                                    #requestDate autocomplete="off" readonly formControlName="request_date">
                                <span class="input-group-text" (click)="filterForm.get('request_date')!.value ? removeDate('request_date') : $event.preventDefault(); requestDate.focus()">
                                    <i class="{{filterForm.get('request_date')!.value ? 'ti ti-x' : 'ti ti-calendar'}}"></i>
                                </span>
                            </div>
                        </div>
                        <div class="col">
                            <label class="form-label text-base">Unidad</label>
                            <select class="form-select" formControlName="unit_id">
                                <option value="">Seleccionar</option>
                                <option *ngFor="let unit of units" [value]="unit.id">{{unit.unit}}</option>
                            </select>
                        </div>
                        <div class="col">
                            <label class="form-label text-base">Fecha de pago</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" placeholder="dd/mm/yyyy" id="date_payment"
                                    #datePayment autocomplete="off" readonly formControlName="date_payment">
                                <span class="input-group-text" (click)="filterForm.get('date_payment')!.value ? removeDate('date_payment') : $event.preventDefault(); datePayment.focus()">
                                    <i class="{{filterForm.get('date_payment')!.value ? 'ti ti-x' : 'ti ti-calendar'}}"></i>
                                </span>
                            </div>
                        </div>
                        <div class="col">
                            <label class="form-label text-base">Tipo de pago</label>
                            <select class="form-select" formControlName="payment_type_id">
                                <option value="">Seleccionar</option>
                                <option *ngFor="let payment of paymentType" [value]="payment.id">{{payment.name}}</option>
                            </select>
                        </div>
                        <div class="col">
                            <label class="form-label text-base">Forma de pago</label>
                            <select class="form-select" formControlName="payment_method_id">
                                <option value="">Seleccionar</option>
                                <option *ngFor="let payment of paymentMethod" [value]="payment.id">{{payment.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div class="row g-3" *ngIf="role?.name == 'Dirección'">
                        <div class="col">
                            <label class="form-label text-base">Folio</label>
                            <input type="text" class="form-control" placeholder="Ingresar" autocomplete="off"
                                formControlName="folio">
                        </div>
                        <div class="col">
                            <label class="form-label text-base">Fecha de solicitud</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" placeholder="dd/mm/yyyy" id="request_date"
                                    #requestDate autocomplete="off" readonly formControlName="request_date">
                                <span class="input-group-text" (click)="filterForm.get('request_date')!.value ? removeDate('request_date') : $event.preventDefault(); requestDate.focus()">
                                    <i class="{{filterForm.get('request_date')!.value ? 'ti ti-x' : 'ti ti-calendar'}}"></i>
                                </span>
                            </div>
                        </div>
                        <div class="col">
                            <label class="form-label text-base">Tipo de mantenimiento</label>
                            <select class="form-select" formControlName="maintenance_type_id">
                                <option value="">Seleccionar</option>
                                <option *ngFor="let type of maintenanceType" [value]="type.id">{{type.name}}</option>
                            </select>
                        </div>
                        <div class="col">
                            <label class="form-label text-base">Estado</label>
                            <select class="form-select" formControlName="maintenance_status_id">
                                <option value="">Seleccionar</option>
                                <option *ngFor="let status of statusMaintenanceDirection" [value]="status.id">{{status.name}}</option>
                            </select>
                        </div>
                        <div class="col">
                            <label class="form-label text-base">Prioridad</label>
                            <select class="form-select" formControlName="priority_id">
                                <option value="">Seleccionar</option>
                                <option *ngFor="let item of priority" [value]="item.id">{{item.name}}</option>
                            </select>
                        </div>
                        <div class="col">
                            <label class="form-label text-base">Unidad</label>
                            <select class="form-select" formControlName="unit_id">
                                <option value="">Seleccionar</option>
                                <option *ngFor="let unit of units" [value]="unit.id">{{unit.unit}}</option>
                            </select>
                        </div>
                    </div>
                </form>

                <div class="filter-panel-footer">
                    <button type="button" class="btn btn-outline-primary flex-fill"
                        (click)="filterForm.reset(); showFilters = false">Cancelar</button>
                    <button type="button" class="btn btn-primary flex-fill"
                        (click)="showFilters = false">Aplicar Filtros</button>
                </div>
            </div>
        </div>
        <div class="card-body">
            <ag-grid-angular class="ag-theme-alpine maintenance-grid" style="width: 100%;" [columnDefs]="columnDefs"
                [defaultColDef]="defaultColDef" (cellClicked)="onCellClicked($event)" (gridReady)="onGridReady($event)">
            </ag-grid-angular>
        </div>
        <div class="card-footer d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
                <label class="me-2">Filas por página:</label>
                <select class="form-select form-select-sm me-2" style="width: auto;"
                    (change)="onPageSizeChanged($any($event.target).value)">
                    <option *ngFor="let s of pageSizeOptions" [value]="s" [selected]="s === pageSize">{{s}}</option>
                </select>
                <button class="btn btn-outline-secondary btn-sm me-2 btn-page" (click)="prevPage()"
                    [disabled]="currentPage <= 1">
                    <i class="ti ti-chevron-left"></i>
                </button>
                <span class="me-2">Página {{currentPage}}</span>
                <button class="btn btn-outline-secondary btn-sm btn-page" (click)="nextPage()"
                    [disabled]="!hasNextPage">
                    <i class="ti ti-chevron-right"></i>
                </button>
            </div>
        </div>
    </div>
</div>

<!-- Backdrop action sheet filtros (solo responsive) -->
<div class="filter-backdrop" [class.show]="showFilters" (click)="showFilters = false"></div>

<ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
    <div class="loader"></div>
    <p style="font-size: 20px; color: white">Espere un momento...</p>
</ngx-spinner>

<!-- Modal Payment -->
<div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="modalPayment" tabindex="-1"
    aria-labelledby="modalPaymentLabel" aria-hidden="true">
    <div class="modal-dialog modal-ms modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header text-center">
                <h4 class="modal-title w-100" id="modalPaymentLabel">{{ typeFormPayment === 1 ? 'Solicitud de pago' :
                    'Registro de pago' }}</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <form [formGroup]="paymentForm">
                    <div class="row">
                        <div class="col-lg-12">
                            <label class="form-label text-base" for="basic-default-company">Forma de pago {{
                                typeFormPayment === 2 ? 'realizado' : '' }}</label>
                            <div class="input-group input-group-merge">
                                <select class="form-select" formControlName="payment_method_id">
                                    <option value="">Seleccionar</option>
                                    <option *ngFor="let item of paymentMethod" [ngValue]="item.id">{{item.name}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-12 mt-3">
                            <label class="form-label text-base" for="basic-default-company">Tipo de pago {{
                                typeFormPayment === 2 ? 'realizado' : '' }}</label>
                            <div class="input-group input-group-merge">
                                <select class="form-select" formControlName="payment_type_id">
                                    <option value="">Seleccionar</option>
                                    <option *ngFor="let item of paymentType" [ngValue]="item.id">{{item.name}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-lg-12 mt-3">
                            <label class="form-label text-base" for="basic-default-company">Monto a pagar</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" id="payment_amount"
                                    formControlName="payment_amount" autocomplete="off" inputmode="decimal"
                                    [imask]="amountMask" [unmask]="'typed'">
                            </div>
                        </div>
                        <div class="col-lg-6 mt-3" *ngIf="paymentTypeId === 1">
                            <label class="form-label text-base" for="basic-default-company">Porcentaje pago
                                parcial</label>
                            <div class="input-group input-group-merge">
                                <input type="number" class="form-control" id="partial_percentage"
                                    formControlName="partial_percentage" autocomplete="off" min="0" max="100">
                            </div>
                        </div>
                        <div class="col-lg-6 mt-3" *ngIf="paymentTypeId === 1">
                            <label class="form-label text-base" for="basic-default-company">Monto restante</label>
                            <div class="input-group input-group-merge">
                                <input type="text" class="form-control" id="remaining_amount"
                                    formControlName="remaining_amount" autocomplete="off" inputmode="decimal"
                                    [imask]="amountMask" [unmask]="'typed'">
                            </div>
                        </div>
                        <div class="col-lg-12 mt-3">
                            <label class="form-label text-base" for="basic-default-company">Fecha de liquidación</label>
                            <div class="input-group input-group-merge">
                                <input type="date" class="form-control" id="settlement_date"
                                    formControlName="settlement_date" autocomplete="off">
                            </div>
                        </div>
                        <div class="col-lg-12 mt-3" *ngIf="typeFormPayment === 2">
                            <div class="input-group input-group-merge" *ngIf="!selectedEvidenceFile">
                                <input type="file" #evidenceInput class="d-none" accept="application/pdf"
                                    formControlName="evidence_file" (change)="onEvidenceFileSelected($event)">
                                <a class="upload_file" (click)="$event.preventDefault(); evidenceInput.click();">
                                    <img src="assets/img/icons/maintenance/upload-04.svg" alt="" class="me-2"
                                        width="20">
                                    Adjuntar comprobante de pago
                                </a>
                            </div>
                            <div class="d-flex align-items-center mt-2" *ngIf="selectedEvidenceFile">
                                <img src="assets/img/icons/maintenance/pdf-02.svg" alt="PDF" width="20" class="me-2">
                                <a (click)="$event.preventDefault(); previewEvidenceFile()" class="me-2 upload_file">
                                    {{ selectedEvidenceFile.name || 'archivo.pdf' }}
                                </a>
                                <a title="Quitar" class="ms-auto cursor-pointer" (click)="clearEvidenceFile()">
                                    <img src="assets/img/icons/maintenance/elements_delete.svg" alt="" width="20">
                                </a>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="button" class="btn btn-outline-primary me-3" style="min-width: 40%"
                    data-bs-dismiss="modal">Cancelar</button>
                <button type="button" class="btn btn-primary" style="min-width: 40%;" [disabled]="paymentForm.invalid"
                    (click)="submitPayment()">{{ typeFormPayment === 2 ? 'Registrar' : 'Solicitar' }}</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalChangedStatus" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="modalChangedStatusLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header text-center">
                <h4 class="modal-title w-100" id="modalChangedStatusLabel">Actualizar estado</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body mb-0 pb-0">
                <div class="row">
                    <div class="col-lg-12">
                        <h5 class="text-center">Selecciona el estado que desea actualizar</h5>
                    </div>
                </div>
                <div class="row">
                    <div class="col d-grid gap-1 mb-1"
                        *ngFor="let item of typeModalChangedStatus == 1 ? statusMaintenanceAdministrative : statusMaintenanceSupervisor">
                        <input type="radio" class="btn-check" name="status_option" id="btn-check-admin-{{item.id}}"
                            [value]="item.id" autocomplete="off" [(ngModel)]="selectedStatusId" [disabled]="typeModalChangedStatus != 1 && item.id <= dataSelected?.maintenance_status_id && ['Pendiente', 'Nivel 0','En reparación', 'Reparado', 'Unidad habilitada'].includes(dataSelected?.maintenance_status?.name)">
                        <label class="btn text-white btn-sm" [style.background-color]="item.color + '!important'"
                            [style.color]="item.text_color + '!important'"
                            for="btn-check-admin-{{item.id}}">{{item.name}}</label>
                    </div>
                </div>
                <hr>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="button" class="btn btn-outline-primary me-3" style="min-width: 40%"
                    data-bs-dismiss="modal">Cancelar</button>
                <button type="button" class="btn btn-primary" style="min-width: 40%" [disabled]="!selectedStatusId"
                    (click)="submitStatusChange()">Actualizar</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalUploadPaymentInvoice" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="modalUploadPaymentInvoiceLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header text-center">
                <h4 class="modal-title w-100" id="modalUploadPaymentInvoiceLabel">Subir factura de pago</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body mb-0 pb-0">
                <div class="row">
                    <div class="col-lg-12 col-xs-12 mt-3">
                        <input type="file" #evidenceInput class="d-none" (change)="onFilesSelected($event)"
                            accept="application/pdf">
                        <!-- Show upload link when no file selected -->
                        <div *ngIf="!selectedPaymentInvoiceFile">
                            <a class="upload_file mt-3 justify-content-between align-items-center"
                                (click)="$event.preventDefault(); evidenceInput.click();">
                                <img src="assets/img/icons/maintenance/upload-04.svg" alt="" class="me-2" width="20">
                                Selecciona la factura de pago
                            </a>
                        </div>
                        <!-- Show selected file when file exists -->
                        <div class="d-flex align-items-center mt-2" *ngIf="selectedPaymentInvoiceFile">
                            <img src="assets/img/icons/maintenance/pdf-02.svg" alt="PDF" width="20" class="me-2">
                            <a (click)="$event.preventDefault(); previewPaymentInvoiceFile()" class="me-2 upload_file">
                                {{ selectedPaymentInvoiceFile.name || 'archivo.pdf' }}
                            </a>
                            <a title="Quitar" class="ms-auto cursor-pointer" (click)="clearPaymentInvoiceFile()">
                                <img src="assets/img/icons/maintenance/elements_delete.svg" alt="" width="20">
                            </a>
                        </div>
                    </div>
                </div>
                <hr>
            </div>
            <div class="modal-footer justify-content-center">
                <button type="button" class="btn btn-outline-primary me-3" style="min-width: 40%"
                    data-bs-dismiss="modal">Cancelar</button>
                <button type="button" class="btn btn-primary" style="min-width: 40%"
                    [disabled]="!selectedPaymentInvoiceFile" (click)="sendPaymentInvoice()">Cargar factura</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalPaymentMaintenance" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="modalPaymentMaintenanceLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header text-center">
                <h4 class="modal-title w-100" id="modalPaymentMaintenanceLabel">Pagos realizados</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body mb-3 pb-0">
                <div class="card mb-2" *ngFor="let payment of paymentsMade">
                    <div class="card-body">
                        <div class="row">
                            <div class="col">
                                <p><b>Fecha creación</b><br>
                                    {{ payment.created_at | date: 'dd/MM/yyyy HH:mm' }}</p>
                            </div>
                            <div class="col">
                                <p><b>Evidencia de pago</b><br>
                                    <a href="{{ urlPage + '/storage/' + payment.path }}" target="_blank">
                                        <img src="assets/img/icons/maintenance/pdf-02.svg" alt="PDF" width="20"
                                            class="me-2">
                                        Ver evidencia
                                    </a>
                                </p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p><b>Método de pago</b><br>
                                    {{ payment.payment_method.name }}</p>
                            </div>
                            <div class="col">
                                <p><b>Tipo de pago</b><br>
                                    {{ payment.payment_type.name }}</p>
                            </div>
                            <div class="col">
                                <p><b>Fecha de Liquidación</b><br>
                                    {{ payment.settlement_date | date: 'dd/MM/yyyy' }}</p>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <p><b>Monto pagado</b><br>
                                    {{ payment?.amount | currency }}</p>
                            </div>
                            <div class="col">
                                <p><b>Porcentaje pagado</b><br>
                                    {{ payment?.percentage || 0 }}%</p>
                            </div>
                            <div class="col">
                                <p><b>Monto restante</b><br>
                                    {{ payment?.remaining_amount || 0 | currency }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalEvidences" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
    aria-labelledby="modalEvidencesLabel" aria-hidden="true">
    <div class="modal-dialog modal-md modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header text-center">
                <h4 class="modal-title w-100" id="modalEvidencesLabel">Evidencias del reporte de falla</h4>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="row" *ngIf="evidences && evidences.length > 0; else noEvidences">
                    <div class="col-12">
                        <div id="carouselExample" class="carousel slide" data-bs-ride="carousel">
                            <div class="carousel-inner">
                                <div class="carousel-item" [class.active]="i === 0"
                                    *ngFor="let evidence of evidences; let i = index">
                                    <img [src]="urlPage + '/storage/' + evidence.path"
                                        [alt]="evidence.name || 'Evidencia ' + (i + 1)" class="d-block w-100"
                                        style="max-height: 400px; object-fit: contain;"
                                        onerror="this.src='assets/img/no-image.png'; this.onerror=null;">
                                </div>
                            </div>
                            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExample"
                                data-bs-slide="prev" *ngIf="evidences.length > 1">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Previous</span>
                            </button>
                            <button class="carousel-control-next" type="button" data-bs-target="#carouselExample"
                                data-bs-slide="next" *ngIf="evidences.length > 1">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="visually-hidden">Next</span>
                            </button>
                        </div>
                    </div>
                </div>
                <ng-template #noEvidences>
                    <div class="col-12 text-center">
                        <div class="d-flex flex-column align-items-center">
                            <i class="ti ti-file-x fs-1 text-muted mb-3"></i>
                            <p class="text-muted mb-2">No hay evidencias disponibles para este reporte.</p>
                            <small class="text-muted">Las evidencias se cargan cuando se registra el reporte de
                                mantenimiento.</small>
                        </div>
                    </div>
                </ng-template>
            </div>
            <div class="modal-footer justify-content-center ">
                <button type="button" class="btn btn-outline-primary w-40" data-bs-dismiss="modal">Cerrar</button>
                <button *ngIf="evidences.length > 0" type="button" class="btn btn-primary w-40"
                    (click)="downloadAllEvidences()">Descargar evidencias</button>
            </div>
        </div>
    </div>
</div>

